import React, { ComponentProps } from 'react'
import { BaseTextLink } from 'components/atoms/link/base_text_link'

type Props = Omit<ComponentProps<typeof BaseTextLink>, 'color' | 'underline'>

export const NavigationTextLink: React.FC<Props> = ({ children, ...props }) => (
  <BaseTextLink color="text" underline="none" {...props}>
    {children}
  </BaseTextLink>
)
